<template>
  <v-card :loading="isLoading">
    <v-card-title v-text="title" />
    <v-card-text>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-text-field
          v-model="form.name"
          :value="data.name"
          :rules="rules.name"
          label="Название категории"
        />

        <searchable-category
          v-model="form.parent"
          :data="data.parent"
          label="Родительская категория"
          placeholder="Введите запрос или выберите категорию"
        />

        <icon-select-component
          v-model="form.iconId"
          :data="data.icon"
          :list="iconList"
          label="Иконка категории"
          search
          search-label="Поиск иконок"
        />

        <v-file-input
          label="Изображение категории"
          accept="image/*"
          :loading="isFileLoading"
          :success="thumbnailLoaded"
          :success-messages="thumbnailSuccessMessage"
          @change="onThumbnailChange"
        />

        <v-img
          v-if="data.thumbnail && isEdit"
          :src="data.thumbnail.path"
          height="200px"
        />

        <v-checkbox
          v-model="form.minimizeMode"
          label="Слои добавляются через модальное окно"
          :value="data.minimizeMode"
        />

        <v-checkbox
          v-model="form.authorizedOnly"
          label="Только для авторизованных пользователей"
          :value="data.authorizedOnly"
        />
      </v-form>
    </v-card-text>
    <v-card-actions>
      <div class="flex-grow-1" />
      <v-btn
        v-if="isEdit"
        color="primary"
        text
        @click="onSubmit"
      >
        Сохранить изменения
      </v-btn>
      <v-btn
        v-else
        color="success"
        text
        @click="onSubmit"
      >
        Создать категорию
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import get from 'lodash/get';
import { uploadFile } from '@/utils/requests/upload';
import IconSelectComponent from '@/components/ui/icon-select';
import SearchableCategory from '@/components/page/categories/searchable-select';

const createDefaultForm = () => ({
  name: null,
  parentId: null,
  parent: null,
  attachmentId: null,
  thumbnail: null,
  iconId: null,
  minimizeMode: null,
  authorizedOnly: true,
});

export default {
  name: 'category-form',

  components: { IconSelectComponent, SearchableCategory },

  model: {
    prop: 'value',
    event: 'change',
  },

  props: {
    value: Object,
    iconList: {
      type: Array,
      default: () => ([]),
    },
    data: {
      type: Object,
      default: createDefaultForm,
    },
    isEdit: Boolean,
    isLoading: Boolean,
  },

  data: () => ({
    form: createDefaultForm(),
    rules: {
      name: [
        v => !!v || 'Поле обязательно для заполнения',
      ],
    },
    valid: true,
    isFileLoading: false,
    thumbnailLoaded: false,
    iconQuery: '',
  }),

  computed: {
    title() {
      return this.isEdit ? 'Изменение категории' : 'Новая категория';
    },

    thumbnailSuccessMessage() {
      return this.thumbnailLoaded ? ['Изображение успешно загружено. Сохраните изменения.'] : [];
    },
  },

  watch: {
    data: {
      deep: true,
      immediate: true,
      handler: 'updateData',
    },
    form: {
      deep: true,
      handler(value) {
        const data = {
          ...value,
          parentId: get(value, 'parent.id', null),
        };

        this.$emit('change', data);
      },
    },
  },

  methods: {
    async onThumbnailChange(file) {
      if (!file) { this.thumbnailLoaded = false; return; }

      this.thumbnailLoaded = false;
      this.isFileLoading = true;

      try {
        const response = await uploadFile(file);
        const { id } = response;

        this.form.attachmentId = id;
        this.thumbnailLoaded = true;
      } catch (e) {
        console.error(e);
      }

      this.isFileLoading = false;
    },

    onSubmit() {
      if (this.$refs.form.validate()) {
        this.$emit('submit', this.form);
      }
    },

    updateData() {
      this.form = {
        ...this.form,
        ...this.data,
        attachmentId: get(this.data, 'thumbnail.id'),
        iconId: get(this.data, 'icon.id'),
      };
    },
  },
};
</script>
